import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable()
export class OEScreenContainerClickListenerService {
  public subject: Subject<MouseEvent> = new Subject();
  public $: Observable<MouseEvent> = this.subject.asObservable();
}
